export const ugeCropTypes = ['original', 'landscape', 'square', 'portrait', 'custom'] as const

type UgeCrop = typeof ugeCropTypes[number]

export function cropAspectRatio(crop: UgeCrop, originalAspectRatio?: number): number | undefined {
    switch (crop) {
        case 'landscape':
            return 16 / 9
        case 'original':
            return originalAspectRatio
        case 'portrait':
            return 9 / 16
        case 'square':
            return 1
        default:
            return
    }
}

export function cropLabel(crop: UgeCrop): string {
    switch (crop) {
        case 'custom':
            return 'Custom'
        case 'landscape':
            return 'Landscape'
        case 'original':
            return 'Original'
        case 'portrait':
            return 'Portrait'
        case 'square':
            return 'Square'
    }
}

export default UgeCrop
